import { Component, DestroyRef, inject } from '@angular/core';
import { GtmService } from '../shared/gtm/gtm.service';
import { UserService } from '../shared/services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'zp-analytics',
    template: '',
    standalone: true
})
export class AnalyticsComponent {

    private destroyRef = inject(DestroyRef);

    constructor(private gtm: GtmService,
                private userService: UserService) {
        this.setInitialData()
    }

    private setInitialData(): AnalyticsComponent {
        this.userService.user$
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(user =>
              this.gtm.sendEvent({
                event: "initialDataLayerData",
                cid: user.publisherDetails.userInfo.clientId,
                userType: "publisher",
                doppelganger: user.publisherDetails.userInfo.userType.includes('Doppelganged'),
                u_s: user.publisherDetails.userInfo.userState,
                'DL - mail': user.publisherDetails.userInfo.email,
              })
          );

        return this;
    }

}
